var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle0, _circle1, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConfetti(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 229,
    height: 147,
    viewBox: "0 0 229 147",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 45.5,
    r: 3.5,
    fill: "#E00B20"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 148.5,
    cy: 139.5,
    r: 3.5,
    fill: "#BE3C9D"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 218.5,
    cy: 143.5,
    r: 3.5,
    fill: "#977FCC"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 184.5,
    cy: 121.5,
    r: 3.5,
    fill: "#EF5621"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 89.5,
    cy: 10.5,
    r: 3.5,
    fill: "#BE3C9D"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 214.5,
    cy: 88.5,
    r: 3.5,
    fill: "#005CCC"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 225.5,
    cy: 55.5,
    r: 3.5,
    fill: "#99D4F2"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 181.5,
    cy: 59.5,
    r: 3.5,
    fill: "#22841F"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 170.5,
    cy: 40.5,
    r: 3.5,
    fill: "#E00B20"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 188.5,
    cy: 13.5,
    r: 3.5,
    fill: "#5C3D99"
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 141.5,
    cy: 7.5,
    r: 3.5,
    fill: "#FFBA23"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 44.5,
    cy: 3.5,
    r: 3.5,
    fill: "#E1B539"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 52.5,
    r: 3.5,
    fill: "#977FCC"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 67.5,
    cy: 140.5,
    r: 3.5,
    fill: "#327B7B"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 33.5,
    cy: 114.5,
    r: 3.5,
    fill: "#22841F"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 92.5,
    r: 3.5,
    fill: "#004B9B"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 128.5,
    r: 3.5,
    fill: "#005CCC"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 29.5,
    cy: 82.5,
    r: 3.5,
    fill: "#EF5621"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfetti);
export default __webpack_public_path__ + "static/media/Confetti.d3c6195ef300281782cb7d9d73809f09.svg";
export { ForwardRef as ReactComponent };